import { MAX_PHOTO_BYTES } from './intake-form.constants';

/** Client-side compression to keep intake photos under the backend's 500KB limit. */
export async function compressPhoto(file: File): Promise<File> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const objectUrl = URL.createObjectURL(file);
    img.onload = () => {
      URL.revokeObjectURL(objectUrl);
      const compress = (w: number, h: number, quality: number): void => {
        const canvas = document.createElement('canvas');
        canvas.width = w;
        canvas.height = h;
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          reject(new Error('Canvas unavailable'));
          return;
        }
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, w, h);
        ctx.drawImage(img, 0, 0, w, h);
        canvas.toBlob(
          (blob) => {
            if (!blob) {
              reject(new Error('Compression failed'));
              return;
            }
            if (blob.size <= MAX_PHOTO_BYTES) {
              resolve(
                new File([blob], file.name.replace(/\.[^.]+$/, '.jpg'), { type: 'image/jpeg' }),
              );
            } else if (quality > 0.15) {
              compress(w, h, quality - 0.1);
            } else if (w > 100) {
              compress(Math.round(w * 0.75), Math.round(h * 0.75), 0.8);
            } else {
              resolve(
                new File([blob], file.name.replace(/\.[^.]+$/, '.jpg'), { type: 'image/jpeg' }),
              );
            }
          },
          'image/jpeg',
          quality,
        );
      };
      compress(img.naturalWidth, img.naturalHeight, 0.9);
    };
    img.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error('Failed to load image'));
    };
    img.src = objectUrl;
  });
}
